let popupevent = {
    init() {

	console.log('that the init')
        // Gestion des clics pour fermer la popup
        $(document).click(function(event) {
            if ($(event.target).hasClass('popup-event')) {
                $(".popup-event").fadeOut(300);
                $('body').removeClass('noscroll');
                popupevent.setCookie('event', 1);
            }
        });

        $('.popup-event .close, .popup-event .btn').click(function() {
            $(".popup-event").fadeOut(300);
            $('body').removeClass('noscroll');
            popupevent.setCookie('event', 1);
        });

        // Attendre 30 secondes avant d'afficher la popup
        setTimeout(() => {
	    console.log('heyyoh TO DELETE')
            popupevent.showPopupAfterDelay();
        }, 30000);
    },

    setCookie(name, value, days) {
        let expires = "";
        if (days) {
            let date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    },

    getCookie(name) {
        let nameEQ = name + "=";
        let ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i].trim();
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },

    eraseCookie(name) {
        document.cookie = name + '=;expires=Thu, 01 Jan 2025 00:00:01 GMT; path=/;';
    },

    showPopupAfterDelay() {
        if (!this.getCookie('event') && $('body').hasClass('event-actif')) {
            $('.popup-event').fadeIn(300);
            $('body').addClass('noscroll');
        }
    }
};

export default popupevent;
